function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function () {
        var self = this, args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { version } from '../../../package.json';
import { XHR } from '@emav-util/network';
import log from '@emav-util/log.js';
var AVBigdataStatistic = function () {
    function AVBigdataStatistic(config) {
        _classCallCheck(this, AVBigdataStatistic);
        var env = config.env;
        var bizWarn = config.bizWarn;
        var res = /(\(.*?\))/.exec(window.navigator.userAgent);
        this.kvs = [
            [
                'version',
                version
            ],
            [
                'platform',
                window.navigator.platform
            ],
            [
                'os_name',
                res[0]
            ],
            [
                'os_version',
                res[0]
            ],
            [
                'app_type',
                window.navigator.userAgent
            ],
            [
                'app_name',
                ''
            ],
            [
                'app_version',
                ''
            ],
            [
                'manufacturer',
                ''
            ],
            [
                'model',
                ''
            ],
            [
                'width',
                window.screen.width
            ],
            [
                'height',
                window.screen.height
            ],
            [
                'referrer',
                window.location.href
            ]
        ];
        this.domain = env === 'production' ? 'gateway.lvb.eastmoney.com' : 'gateway-qas.lvb.eastmoney.com';
        this.enable = false;
        this.config = config;
        this.bigdata_code = 'emav@langke';
        if (config.statistic && config.statistic.bd && config.statistic.bd.extinfo) {
            if (typeof sendTrackLog === 'undefined') {
                bizWarn({
                    code: 0,
                    message: '大数据埋点参数配置错误\uFF01'
                });
            } else {
                this.enable = true;
                this.bd = config.statistic.bd;
            }
        }
        console.log('[AVBigdataStatistic]\uFF1A', env, config, this.enable);
    }
    _createClass(AVBigdataStatistic, [
        {
            key: 'avBigdataStatistic',
            value: function () {
                var _avBigdataStatistic = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id, duration, avInfo) {
                    var self, biz_data;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                console.log('[avBigdataStatistic]:', id, duration, avInfo, this);
                                if (self.enable && avInfo !== 'undefined' && avInfo.fixed) {
                                    biz_data = {
                                        op: 'activeTime',
                                        id: id,
                                        duration: duration,
                                        avStatus: avInfo.is_live ? 1 : 2,
                                        avType: avInfo.is_audio ? 1 : 2,
                                        avCreateTime: avInfo.start_time,
                                        UID: self.bd.extinfo.UID,
                                        bu: self.bd.extinfo.bu,
                                        plat: self.bd.extinfo.plat
                                    };
                                    window.sendTrackLog('emav', 'click', self.bigdata_code, self.format(biz_data), window.location.href);
                                }
                            case 3:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
                function avBigdataStatistic(_x, _x2, _x3) {
                    return _avBigdataStatistic.apply(this, arguments);
                }
                return avBigdataStatistic;
            }()
        },
        {
            key: 'format',
            value: function format(data) {
                return 'op:'.concat(data.op, ';id:').concat(data.id, ';duration:').concat(data.duration, ';avStatus:').concat(data.avStatus, ';avType:').concat(data.avType, ';avCreateTime:').concat(data.avCreateTime, ';UID:').concat(data.UID, ';bu:').concat(data.bu, ';plat:').concat(data.plat);
            }
        }
    ]);
    return AVBigdataStatistic;
}();
export {
    AVBigdataStatistic as default
};